import React from "react";
import { Grid, Typography, Menu, MenuItem } from "@material-ui/core";
import { Lens, Settings } from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import { useSelector, useDispatch } from "react-redux";
import { userSelector } from "../common/redux/selectors";
import { LOGOUT, UPDATE_SUBSCRIPTION } from "../common/redux/actions";
import { EmailSubscriptionDialogAndMenuItem } from "./EmailSubscriptionDialogAndMenuItem";

export const UserDetails: React.FC = () => {
  const user = useSelector(userSelector);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onUpdateSubscription = (
    subscribeToEmails: boolean,
    upn: string,
    token: string
  ) => {
    dispatch({
      type: UPDATE_SUBSCRIPTION,
      payload: { subscribeToEmails, upn, token },
    });
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      <Grid item xs={3} sm={3}>
        <IconButton color="inherit">
          <Lens fontSize="large" />
        </IconButton>
      </Grid>
      <Grid item xs={6} sm={6} style={{ wordBreak: "break-word" }}>
        <Typography variant="h6">{user?.displayName}</Typography>
        <Typography variant="subtitle1">{user?.org?.name} </Typography>
      </Grid>
      <Grid item xs={3} sm={3}>
        <IconButton
          aria-label="User Settings"
          aria-haspopup="true"
          color="inherit"
          style={{ fontSize: 16 }}
          onClick={handleClick}
        >
          <Settings fontSize="inherit" />
          <Typography variant="srOnly">User settings</Typography>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem
            onClick={() => {
              dispatch({ type: LOGOUT });
              handleClose();
            }}
          >
            Logout
          </MenuItem>
          <EmailSubscriptionDialogAndMenuItem
            user={user}
            onUpdateSubscription={onUpdateSubscription}
          />
        </Menu>
      </Grid>
    </Grid>
  );
};
